export type ProductCategory = {
  key: string | number;
  name: string;
  iconName?: string;
  type?: string;
};

export type IMenuCategory = ProductCategory & {
  imageUrl?: string;
  isHasModifiers?: boolean;
  scanCode?: string;
  rewardPoints?: number;
};
export const CategoryType = {
  All: 'All',
  Product: 'Product',
  Menu: 'Menu',
  TopMenu: 'TopMenu',
};
